import React from "react";
import { Box } from "@mui/material";
import { chainIcons } from "../../config/constants";

const CHAIN_NAMES: Record<string, string> = {
  ETH: "Ethereum",
  ARB: "Arbitrum",
  RSK: "Rootstock",
};

export const chainName = (chain: string) => CHAIN_NAMES[chain.toUpperCase()] ?? chain;

/** Resolves the chain prefix from a bot or family id (e.g. ETH_USDC_WETH_1 → ETH). */
export const chainOf = (botOrFamily: string) => botOrFamily.split("_")[0]?.toUpperCase() ?? "";

/** Pair label from a family/bot id: ETH_USDC_WETH_2 → "USDC / WETH". */
export const pairOf = (botOrFamily: string) =>
  botOrFamily
    .replace(/_\d+$/, "")
    .split("_")
    .slice(1)
    .join(" / ");

interface ChainAvatarProps {
  chain: string;
  size?: number;
}

/** Chain logo in a soft round frame; falls back to the chain initials. */
export const ChainAvatar: React.FC<ChainAvatarProps> = ({ chain, size = 22 }) => {
  const key = chain.toUpperCase();
  const icon = chainIcons[key];
  return (
    <Box
      component="span"
      title={chainName(key)}
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        flexShrink: 0,
        display: "inline-grid",
        placeItems: "center",
        bgcolor: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.08)",
        overflow: "hidden",
        fontSize: size * 0.38,
        fontWeight: 700,
        color: "text.secondary",
      }}
    >
      {icon ? (
        <Box
          component="img"
          src={icon}
          alt=""
          sx={{ width: size * 0.62, height: size * 0.62, objectFit: "contain" }}
        />
      ) : (
        key.slice(0, 2)
      )}
    </Box>
  );
};

export default ChainAvatar;
